/* src/app/shared/components/ag-breadcrumb/ag-breadcrumb.component.scss */
.content-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 88px;
  gap: 20px;
}
.paths-container {
  display: flex;
  flex-direction: row;
  gap: 20px;
  height: 100%;
  align-items: center;
}
.p-item {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px;
  color: #222222;
}
.patch-back {
  font-family: "Poppins-Regular";
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px;
  color: #222222;
}
.path-back:hover {
  cursor: pointer;
}
.arrow {
  width: 24px;
  height: 18px;
}
.current-path {
  font-family: "Poppins-Regular";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  background:
    linear-gradient(
      to top right,
      #4f356e,
      #625da3,
      #6973be,
      #6e89da,
      #9690e4,
      #ba96eb,
      #cb9def);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
/*# sourceMappingURL=ag-breadcrumb.component.css.map */
